import { Store } from "@retailtune/types/lib/store";
import {
  ActiveLanguage,
  createLanguagSidebarContent,
} from "../common/languageSidebar";
import { Translations } from "../common/translations";
import { getDevice } from "@retailtune/utils";
import {
  AnalyticsAction,
  AnalyticsCategory,
} from "@retailtune/types/lib/analytics";
import { createSidebar } from "@retailtune/vanilla-ui-core";
import Swiper from "swiper";
import { Pagination } from "swiper/modules";
import "swiper/css";

declare const retailTuneConfigs: {
  urlPrefix: string;
  language: string;
  alternatesArray: ActiveLanguage[];
  store: Store;
  translations: Translations;
  imgOnlyCampaignIds: number[];
  imgAndTextCampaignIds: number[];
  imgOnlyPromotionIds: number[];
  imgAndTextPromotionIds: number[];
};

// Analytics
declare function sendGa4DL(
  category: AnalyticsCategory,
  action: AnalyticsAction,
  label: string,
  storeId: number
): void;

let deviceType = getDevice();

function main() {
  let showSidebar: (shouldShow: boolean) => void;

  const {
    urlPrefix,
    language,
    alternatesArray,
    store,
    translations,
    imgOnlyCampaignIds,
    imgAndTextCampaignIds,
    imgOnlyPromotionIds,
    imgAndTextPromotionIds,
  } = retailTuneConfigs;

  const campaignsArray = imgOnlyCampaignIds.concat(
    imgAndTextCampaignIds,
    imgOnlyPromotionIds,
    imgAndTextPromotionIds
  );

  window.onresize = () => {
    deviceType = getDevice();
  };

  // * --------------------------------------------------------------------------------------
  // * navigation button's event listener
  // * --------------------------------------------------------------------------------------

  const navigationButton = document.getElementById(
    "rt_bring_me_here_butt"
  ) as HTMLAnchorElement;
  navigationButton.href = `${urlPrefix}/${language}?code=${store.storeCode}`;
  navigationButton.onclick = () => {
    // Analytics
    sendGa4DL(
      "Store",
      "Click",
      `DirectionsClickConcierge-${store.city} ${store.address1}-${deviceType}-${language}`,
      store.id
    );
  };

  // * --------------------------------------------------------------------------------------
  // * languages sidebar creation
  // * --------------------------------------------------------------------------------------

  [showSidebar] = createSidebar({
    anchor: "rt_concierge",
    position: "right",
    content: createLanguagSidebarContent(alternatesArray, language, urlPrefix),
  });

  const storePhoneEl = document.getElementById("rt_store_phone");
  if (storePhoneEl) {
    storePhoneEl.onclick = () => {
      sendGa4DL(
        "Store",
        "Click",
        `PhoneClickConcierge-${store.city} ${store.address1}-${deviceType}-${language}`,
        store.id
      );
    };
  }

  const storeWhatsAppEl = document.getElementById("rt_store_whatsapp");
  if (storeWhatsAppEl) {
    storeWhatsAppEl.onclick = () => {
      sendGa4DL(
        "Store",
        "Click",
        `WhatsappClickConcierge-${store.city} ${store.address1}-${deviceType}-${language}`,
        store.id
      );
    };
  }

  for (let i = 0; i < campaignsArray.length; ++i) {
    // Analytics
    sendGa4DL(
      "CTA",
      "View",
      `${store.storeCode} ${store.city} ${store.address1} - ${campaignsArray[i]} - SL - ${language}`,
      store.id
    );
    const campaignImg = document.getElementById(
      `rt_campaign_${campaignsArray[i]}`
    );
    if (campaignImg) {
      campaignImg.onclick = () => {
        // Analytics
        sendGa4DL(
          "CTA",
          "Click",
          `${store.storeCode} ${store.city} ${store.address1} - ${campaignsArray[i]} - SL - ${language}`,
          store.id
        );
      };
    }
  }

  // * --------------------------------------------------------------------------------------
  // * accordion(s) opening/closing
  // * --------------------------------------------------------------------------------------
  const accordions = document.querySelectorAll(".rt-accordion__heading");
  accordions.forEach((a) =>
    a.addEventListener("click", () =>
      a.parentElement?.classList.toggle("rt-accordion--open")
    )
  );

  // * --------------------------------------------------------------------------------------
  // * sidebar(s) opening/closing
  // * --------------------------------------------------------------------------------------

  const languagesButton = document.getElementById("rt_languages_button")!;
  languagesButton.onclick = () => showSidebar(true);

  // * --------------------------------------------------------------------------------------
  // * initialization of the sliders
  // * --------------------------------------------------------------------------------------
  const a = new Swiper(".rt-campaigns .swiper", {
    slidesPerView: 1,
    spaceBetween: 50,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    grabCursor: true,
    modules: [Pagination],
  });

  // * ------------------------------------------------------------------------
  // * Reviews setup
  // * By default reviews are shown only up to a maximum of "maxReviews".
  // * If more reviews are present, a button "show more/show less" is rendered
  // * ------------------------------------------------------------------------

  // arbitrary value
  const maxReviews = 6;
  // number of total reviews
  let reviewsNumber = 0;

  const reviewsEl = document.querySelector(".rt-reviews__list");

  if (reviewsEl) {
    reviewsNumber = reviewsEl.childElementCount;
  }

  // If reviews are less than maxReviews, we do nothing
  if (reviewsEl && reviewsNumber > 0 && reviewsNumber > maxReviews) {
    // Otherwise, we take the remaining reviews and we hide them
    const remainingReviews = reviewsEl.querySelectorAll(
      `li:nth-child(n + ${maxReviews + 1}`
    );

    remainingReviews.forEach((r) =>
      r.classList.add("rt-reviews__item--hidden")
    );

    // Now we retrieve the button and we add its onclick toggling logic
    const showMoreLessBtn = document.querySelector(
      ".rt-btn-show-more"
    ) as HTMLButtonElement;

    showMoreLessBtn.classList.add("rt-btn-show-more--visible");
    showMoreLessBtn.textContent = translations.k_reviews_show_more;

    showMoreLessBtn.onclick = () => {
      remainingReviews.forEach((r) =>
        r.classList.toggle("rt-reviews__item--hidden")
      );
      showMoreLessBtn.classList.toggle("rt-btn-show-more--opened");
      showMoreLessBtn.textContent = showMoreLessBtn.classList.contains(
        "rt-btn-show-more--opened"
      )
        ? translations.k_reviews_show_less
        : translations.k_reviews_show_more;
    };
  }
}

let i = setInterval(() => {
  try {
    if (!retailTuneConfigs || !sendGa4DL)
      throw new Error("Inexisting required objects to load this page!");
    clearInterval(i);
    main();
  } catch (error) {
    console.warn(error);
  }
}, 50);
